const machineGroup = [
  {
    width: 150,
    key: "sn",
    title: "序列号",
  },

  {
    key: "site_name",
    title: "站点",
  },
  {
    key: "company_name",
    title: "学校",
  },
  {
    width: 100,
    key: "brand",
    title: "机器品牌",
  },
  {
    key: "agent_name",
    title: "合作伙伴",
  },
  {
    width: 120,
    key: "happed",
    title: "印量",
    fixed: "right",
  },
  {
    width: 120,
    key: "mono_happed",
    title: "印量（黑白）",
    fixed: "right",
  },
  {
    width: 120,
    key: "color_happed",
    title: "印量（彩色）",
    fixed: "right",
  },
];

const companyGroup = [
  {
    key: "company_name",
    title: "学校名称",
  },
  {
    key: "agent_name",
    title: "合作伙伴",
  },
  {
    width: 120,
    key: "happed",
    title: "印量",
    fixed: "right",
  },
  {
    width: 120,
    key: "mono_happed",
    title: "印量（黑白）",
    fixed: "right",
  },
  {
    width: 120,
    key: "color_happed",
    title: "印量（彩色）",
    fixed: "right",
  },

]

const siteGroup = [
  {
    key: "name",
    title: "站点名称",
  },
  {
    key: "agent_name",
    title: "合作伙伴",
  },
  {
    width: 120,
    key: "happed",
    title: "印量",
    fixed: "right",
  },
  {
    width: 120,
    key: "mono_happed",
    title: "印量（黑白）",
    fixed: "right",
  },
  {
    width: 120,
    key: "color_happed",
    title: "印量（彩色）",
    fixed: "right",
  },
]


export  { machineGroup, companyGroup, siteGroup };
